__webpack_require__.p = "/power-consumption-calculator/";